import { set_auth,get_token,get_user_id } from '@/router/index.js';
import { get_domain_style } from '@/main';

export default {
  name: 'FirstTimeLogin',
  data: () => ({
    form: {
      new_password: '',
      confirm_password: '',
    },
    errors: {
      new_password: '',
      confirm_password: '',
    },
    global_error: '',
    global_success: '',
    loading: false,
    password_visible: false,
    confirm_password_visible: false,
    current_year: new Date().getFullYear(),
    meets_criteria: {
      length: false,
      lowercase: false,
      uppercase: false,
      special: false,
    },
  }),
  computed: {
    styleConfig() {
      return get_domain_style();
    },
    powered_by_name() {
      return this.styleConfig.powered_by_name;
    },
  },

  watch: {
    'form.new_password'(newVal) {
      this.check_password_criteria(newVal);
    },
  },

  methods: {

    check_password_criteria(password) {
      this.meets_criteria = {
        length: password.length >= 8,
        lowercase: /[a-z]/.test(password),
        uppercase: /[A-Z]/.test(password),
        special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
      };
    },
    toggle_password_visibility(which) {
      if (which === 'password') this.password_visible = !this.password_visible;
      if (which === 'confirm') this.confirm_password_visible = !this.confirm_password_visible;
    },
    validate_form() {
      let valid = true;

      if (!this.form.new_password) {
        this.$notyf.error('Password must be at least 8 characters.');
        valid = false;
      }
      else if (!this.form.confirm_password) {
        this.$notyf.error('Please confirm your new password.');
        valid = false;
      } else if (this.form.confirm_password !== this.form.new_password) {
        this.$notyf.error('New and confirm passwords do not match.');
        valid = false;
      }
      else if (!Object.values(this.meets_criteria).every(Boolean)) {
        this.$notyf.error('Password does not meet required criteria.');
        valid = false;
      }
      return valid;
    },

    async submit_form() {
      if (!this.validate_form()) return;

      const token = get_token();
      const user_id = get_user_id();

      if (!token || !user_id) {
        this.$notyf?.error?.('Missing session token or user id.');
        this.$router?.push('/login');
        return;
      }

      this.loading = true;

      const url = ((process.env.VUE_APP_API_BASE_URL || '') + '/aic_one_api/system_management/first_time_login_view/');

      const payload = {
        new_password: this.form.new_password,
        confirm_password: this.form.confirm_password,
        user_id: user_id,
      };

      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
          },
          body: JSON.stringify(payload),
        });

        const data = await res.json().catch(() => ({}));

        if (res.ok && data?.status === 'success') {
          const fresh_token = data?.data?.token;
          const user = data?.data?.user;
          if (fresh_token && user?.id) {
            sessionStorage.setItem('token', fresh_token);
            sessionStorage.setItem('user_id', String(user.id));

            set_auth(fresh_token, user.id);
          }

          this.global_success = 'Password updated successfully.';
          this.$router?.push('/home')
          return;
        }

        if (data?.errors) {
          this.errors.new_password = data.errors.new_password || '';
          this.errors.confirm_password = data.errors.confirm_password || '';
        }

        const message = data?.message || 'Failed to update password.';
        this.global_error = message;
        this.$notyf?.error?.(message);

      } catch (e) {
        this.global_error = 'Unexpected error. Please try again.';
        this.$notyf?.error?.('Unexpected error during password update.');
      } finally {
        this.loading = false;
      }
    },
  },
};
